<!-- China -->
<template>
  <div class="china_box" ref="china" :style="{width: width, height: height}" :class="className"></div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

import './china.js'
import { convertData } from './mapData'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '450px'
    },
    className: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    // 这里存放数据
    return {
      myChart: ''
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    dataList (n, o) {
      // console.log('china n:', n)
      let siteInfoData = []
      let geoCoordMap = {}
      n.forEach(item => {
        geoCoordMap[item.siteName] = [item.lng, item.lat] // 站点坐标
        siteInfoData.push({
          name: item.siteInfo.siteName, // 站点名称
          value: '-', // 充电桩数(暂无数据)
          quantity: item.siteInfo.chargingAmount, // 总充电量
          chargeFee: item.siteInfo.incomeAmount, // 总收入
          chargeTimes: item.siteInfo.orderCount // 总订单数
        })
      })
      this.drawLine(this.myChart, siteInfoData, geoCoordMap)
    }
  },
  // 方法集合
  methods: {
    drawLine (myChart, data = [], geoCoordMap = {}) {
      // 基于准备好的dom，初始化echarts实例
      if (!myChart) {
        myChart = this.$echarts.init(this.$refs.china)
      }
      let initOption = {
        backgroundColor: 'rgba(0,0,0,0)',
        // backgroundColor: '#08143e',
        title: {
          text: '充电桩分布图',
          top: '10px',
          left: 'center',
          textStyle: {
            color: '#ccc'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            // console.log(params);
            return '充电站名：' + params.name + '<br />' + '充电桩数（个）：' + params.data.value[2] +
              '<br />' + '总充电量（度）：' + params.data.quantity + '<br />' +
              '总充电金额（元）：' + params.data.chargeFee + '<br />' + '总充电次数（次）：' + params.data.chargeTimes
          }
        },
        legend: {
          orient: 'vertical',
          y: 'bottom',
          x: 'right',
          data: ['充电桩数'],
          textStyle: {
            color: '#fff'
          }
        },
        geo: {
          map: 'china',
          label: {
            emphasis: {
              color: 'white',
              show: true
            }
          },
          roam: true,
          zoom: 1.2,
          itemStyle: {
            normal: {
              areaColor: 'rgba(7,21,57,0.5)',
              borderColor: '#0177ff'
            },
            emphasis: {
              areaColor: '#035cc8'// 鼠标指上市时的颜色
            }
          }
        },
        series: [
          {
            name: '充电桩数',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: convertData(data, geoCoordMap),
            encode: {
              value: 2
            },
            symbolSize: function (val) {
              // return val[2] / 10;
              return 20
            },
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: false
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#ddb926'
              }
            }
          },
          {
            // name: 'Top 3',
            name: '充电站',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: convertData(data.sort(function (a, b) {
              return b.value - a.value
              // }).slice(0, 3)),
            }), geoCoordMap),
            encode: {
              value: 2
            },
            symbolSize: function (val) {
              // return val[2] / 10;
              return 20
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: '#f4e925',
                shadowBlur: 10,
                shadowColor: '#333'
              }
            },
            zlevel: 1
          }
        ]
      }
      // 绘制图表
      myChart.setOption(initOption)
      window.addEventListener('resize', myChart.resize)
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.drawLine(this.myChart)
  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () {
  }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
  .china_box{
    width: 49%;
  }
</style>



// WEBPACK FOOTER //
// src/components/China/index.vue